export default "__VITE_ASSET__daf5cd4b__"